import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Scrollspy from 'react-scrollspy';

import colors from 'shared-assets/lib/colors';
import styles from 'shared-assets/lib/styles';

const Div = styled.div`
  && {
    ${props => {
      if (props.sticky) {
        return `
      position: sticky;
      top: ${typeof props.sticky === 'boolean' ? 0 : props.sticky};
      `;
      }
    }};
  }

  ul {
    box-shadow: ${styles.boxShadow};
    border-radius: ${styles.borderRadius};
    margin: 0;
    padding: 1rem;
    > li {
      display: block;

      &.active {
        background: rgba(0, 0, 0, 0.03);
      }

      a {
        border-radius: ${styles.borderRadius};
        color: ${colors.primary};
        display: block;
        outline: none;
        padding: 0.5em 0.75em;
        text-decoration: none;

        &.active {
          background: rgba(0, 0, 0, 0.03);
        }

        &:hover {
          background-color: rgba(0, 0, 0, 0.015);
        }
      }
    }
  }
`;

function VerticalNav(props) {
  let { items, spyOn, ...rest } = props;
  return (
    <Choose>
      <When condition={props.spyOn}>
        <Div {...rest}>
          <Scrollspy items={props.spyOn} currentClassName="active">
            <For each="item" of={items} index="index">
              <li key={index}>{item}</li>
            </For>
          </Scrollspy>
        </Div>
      </When>
      <Otherwise>
        <Div {...rest}>
          <ul className="tebra-nav">
            <For each="item" of={items} index="index">
              <li key={index}>{item}</li>
            </For>
          </ul>
        </Div>
      </Otherwise>
    </Choose>
  );
}

VerticalNav.defaultProps = {
  className: '',
  sticky: false,
  style: {},
  spyOn: undefined,
};

VerticalNav.propTypes = {
  className: PropTypes.string,
  items: PropTypes.array.isRequired,
  spyOn: PropTypes.arrayOf(PropTypes.string),
  sticky: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  style: PropTypes.object,
};

export default VerticalNav;
